// Dependencies
import React from 'react'
import {connect} from 'react-redux'

// Components
import ConfidenceBar from './ConfidenceBar'

// Actions
import {storePayload} from '../actions/storePayload'

// Styles
import '../styles/SubSection.css'

function SubSection(props) {
  function onClickResources() {
    props.storePayload({
      isResourcesModalShowing: true,
      isResourcesModal: true,
    })
  }

  function onClickReferences() {
    props.storePayload({
      isReferencesModalShowing: true,
      isReferencesModal: true,
      references: props.references,
    })
  }

  const decimalConfidence =
    isNaN(props.completed/props.total) ?
        0 :
        (props.completed/props.total)

  return (
    <div
      className={
        `subSection ${
          props.isSelected ?
            'selected' :
            ''
        }`
      }
      style={props.style || {}}
      onClick={props.onClick}
      key={props.key}
    >
      <p>{props.number}</p>
      <p className='subSection-title'>{props.title}</p>
      <div className='subSection-status'>
        <span>{`${props.completed}/${props.total}`}</span>
        <span>{props.status || ''}</span>
      </div>
      <div className='confidence-container'>
        <ConfidenceBar
          confidence={decimalConfidence}
          color={'#219653'}
        />
        <span className='confidence'>
          {`${(decimalConfidence * 100).toFixed(0)}%`}
        </span>
      </div>
      {(props.resources || props.references) &&
        <div
          className='resources'
        >
          {props.resources &&
            <div
              className='resource'
              onClick={onClickResources}
            >
              Resources & Support
            </div>
          }
          {props.references &&
            <div
              className='resource'
              onClick={onClickReferences}
            >
              References
            </div>
          }
        </div>
      }
    </div>
  )
}

const mapStateToProps = (state) => ({
  theme: state.userReducer.theme,
  selectedSubSection: state.userReducer.selectedSubSection,
  isResourcesModal: state.userReducer.isResourcesModal,
  isResourcesModalShowing: state.userReducer.isResourcesModalShowing,
  isReferencesModal: state.userReducer.isReferencesModal,
  isReferencesModalShowing: state.userReducer.isReferencesModalShowing,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(SubSection)

